<!--
  The content of the payment confirmation, not a modal in its own right.

  This used to wrap itself in its own ModalView, bound to an isVisible prop that none of
  its three callers passed - AncestryDetails, BloodDetails and HealthStore all render it
  as the slot of a ModalView they own and give it only orderKey. So isVisible was always
  undefined, the inner modal never rendered, and what the customer saw after paying was
  the outer modal: a "Payment" header over nothing, no buttons, and showCloseButton
  false, so no way to dismiss it either.
-->
<template>
  <div class="form-checkout-container d-flex justify-content-center align-items-center flex-column padding-5">
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img src="@/assets/success.svg" class="gap-4" />
      <!-- Guarded: a render error here blanks the whole confirmation, which is the state
           this component was already in for a different reason. -->
      <p class="order-font">Your Order ID is <strong>{{ (orderKey || "").split("-").pop() }}</strong></p>
      <p class="order-desc">Your order has been successfully placed, and a confirmation sent to your email address. If you need any help please contact help@livingdna.com</p>
    </div>
    <div class="success-actions">
      <router-link :to="{ name: 'dashboard' }" custom v-slot="{ navigate }">
        <button class="ldna-btn" @click="navigate">Go to my dashboard</button>
      </router-link>
      <router-link :to="{ name: 'HealthStore' }" custom v-slot="{ navigate }">
        <button class="ldna-btn ldna-btn--secondary" @click="navigate">Back to store</button>
      </router-link>
    </div>
  </div>
</template>

<script>
import "@/styles/pages/BloodTestDetails.scss";

export default {
  name: 'SuccessModal',
  props: {
    orderKey: String
  },
  mounted() {
    console.log("Success", this.orderKey)
  }
};
</script>

<style scoped>
/* Stacked, full-width buttons */
.success-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 320px;
  margin-top: 32px;
}
</style>
